import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import KeysByMonthByGameList from './components/month/KeysByMonthByGameList';
import KeysByWeekByGameList from './components/week/KeysByWeekByGameList';

function KeysByGame() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Keys by game"
      MonthList={KeysByMonthByGameList}
      WeekList={KeysByWeekByGameList}
      storageKey="report-group-by"
    />
  );
}

export default KeysByGame;
